import React from 'react';
import { Tooltip } from 'bootstrap';

import {ConnectionFailureAlert} from '@/Components/AutoSave';

export default class NavBarUI extends React.Component {
    constructor(props) {
        super(props);

        this.sectionTitleRef = React.createRef();
        this.actionButtonRef = React.createRef();
        this.stickyCheckRef = React.createRef();
        this.navBarRef = React.createRef();
    }

    componentDidMount() {
        this.initTooltip();
        this.initStuckCheck();
    }

    initTooltip() {
        this.titleTooltip = new Tooltip(this.sectionTitleRef.current);
        this.handleTooltipVisibility(this.titleTooltip, this.sectionTitleRef.current);

        window.addEventListener('resize', () => this.handleTooltipVisibility(this.titleTooltip, this.sectionTitleRef.current));
    }

    handleTooltipVisibility(titleTooltip, sectionTitle) {
        let display = sectionTitle.offsetWidth < sectionTitle.scrollWidth;
        display ? titleTooltip.enable() : titleTooltip.disable();
    }

    initStuckCheck() {
        const observer = new IntersectionObserver(([event]) => {
            this.navBarRef.current.classList.toggle('is-stuck', event.intersectionRatio === 0);
        }, {
            threshold: [0]
        });
        observer.observe(this.stickyCheckRef.current);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sectionNumber !== this.props.sectionNumber || prevProps.lostConnection !== this.props.lostConnection) {
            $(this.actionButtonRef.current).animateCss('flipInY');
        }
    }

    renderSectionTitle() {
        return (
            <div
                className="section-title text-truncate"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                data-bs-dely="50"
                title={this.props.sectionTitle}
                ref={this.sectionTitleRef}
            >
                {this.props.sectionTitle}
            </div>
        );
    }

    renderActionButtonLabel() {
        let label = undefined;

        switch (this.props.sectionType) {
            case 'blog_post':
            case 'publication':
            case 'single_html_page':
            case 'test_results':
                label = "Next";
                break;
            case 'test':
                label = "Submit";
                break;
        }

        return label;
    }

    renderActionButton() {
        switch (this.props.sectionType) {
            case 'blog_post':
            case 'publication':
            case 'single_html_page':
            case 'test_results':
                return this.renderNextButton();
            case 'test':
                return this.renderSubmitButton();
        }
    }

    renderNextButton() {
        let disabled = this.props.lostConnection ? ' disabled' : '';

        return (
            <button
                className={"btn btn-primary next-button d-flex" + disabled}
                onClick={this.props.navigateNext}
                ref={this.actionButtonRef}
                tabIndex="0"
            >
                <span>Next</span> <i className="material-icons">arrow_forward</i>
            </button>
        );
    }

    renderSubmitButton() {
        let disabled = this.props.lostConnection ? ' disabled' : '';

        return (
            <button
                className={"btn btn-success next-button d-flex" + disabled}
                onClick={() => this.props.submitButtonRef.current.click()}
                ref={this.actionButtonRef}
                tabIndex="0"
            >
                <i className="material-icons">check</i> <span>Submit</span>
            </button>
        )
    }

    renderBackButton() {
        if (!this.props.backButton) return;
        let disabled = this.props.lostConnection ? ' disabled' : '';

        return (
            <button className={"btn back-button d-flex" + disabled} onClick={this.props.navigateBack} tabIndex="0">
                <i className="material-icons">arrow_back</i> <span className="button-text">Back</span>
            </button>
        );
    }

    render() {
        let actionButton = undefined;
        let backEnabledClass = this.props.backButton ? ' back-enabled' : '';

        if (!this.props.disableNavigation && (this.props.sectionType === 'test' || !this.props.atEnd)) {
            actionButton = this.renderActionButton();
        }

        return (
            <>
                <div className="sticky-check" ref={this.stickyCheckRef}></div>
                <div className={"nav-bar sticky-top d-flex align-items-center" + backEnabledClass}
                     ref={this.navBarRef}
                >
                    {this.renderBackButton()}
                    {this.renderSectionTitle()}
                    {actionButton}
                    <ConnectionFailureAlert />
                </div>
            </>
        );
    }
}
